"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.percentageFormatter = exports.numberFormatter = exports.currencyFormatter = void 0;
const currencyFormatter = (number, maxNumDigits = 0, minNumDigits = 0) => {
    const result = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: minNumDigits,
        maximumFractionDigits: maxNumDigits,
    }).format(number);
    return result;
};
exports.currencyFormatter = currencyFormatter;
const numberFormatter = (number, numDigits = 0) => {
    const result = new Intl.NumberFormat('en-AU', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: numDigits,
    }).format(number);
    return result;
};
exports.numberFormatter = numberFormatter;
const percentageFormatter = (number, maximumFractionDigits = 2, minimumFractionDigits = 2) => {
    //NOTE:Percentage formatter is returning 0% after rounding off number wherein number < 0.01,In that case we are changing numDigits to display to 2.
    if (number < 0.01) {
        maximumFractionDigits = 2;
    }
    const result = new Intl.NumberFormat('en-AU', {
        style: 'percent',
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits,
    }).format(number);
    return result;
};
exports.percentageFormatter = percentageFormatter;
